function EmptyCart(): JSX.Element {
  return (
    <div className="container">
      <h2>Корзина пустая</h2>
    </div>
  );
}

export default EmptyCart;
